import { Injectable } from '@angular/core';
import { InquiryModel } from 'app/models';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';

@Injectable()
export class BoatInquiryService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getAllInquiries(data: InquiryModel, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/BoatInquiry/GetInquiries', data, messageService);
    }

    public exportBoatInquiries(data: InquiryModel, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/BoatInquiry/ExportBoatInquiry', data, messageService);
    }
}
